module.exports = __webpack_public_path__ + "static/media/bookmark.865666b8.svg";